import {Component} from 'substance'
import './scss/progress.scss'

/**
 * @typedef Component.UIProgress.Props
 * @property {int} value - The value of the progress bar
 * @property {int} max - Optional max value, defaults to 100
 */

/**
 * Create a simple progress bar
 *
 * @memberof Component
 *
 * @example
 * import {UIProgress} from 'writer'
 *
 * render($$) {
 *     const el = $$('div')
 *     return el.append(
 *         $$(UIButton, {
 *             value: 1,
 *             max: 100
 *         })
 *     )
 * }
 *
 * @param {Component.UIProgress.Props} props
 * @property {Component.UIProgress.Props} props
 */
class ProgressComponent extends Component {

    render($$) {

        const {value, max = 100} = this.props

        return $$('div')
            .addClass('dwc-progress')
            .append(
                $$('progress')
                    .attr({
                        value,
                        max
                    })
            )
    }
}

export {ProgressComponent}
